const Pikaday = require('pikaday');
const Moment = require('moment');
const pickField = document.getElementById('datepicker');

if (pickField) {
	// this is a bit evil, but on ios / android use the native picker
	if( /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ) {

	}
	else {

		Moment.locale('nb');

		let minDate = pickField.min;
		let maxDate = pickField.max;
		let curDate = pickField.value;

		pickField.type = 'text';
		pickField.readOnly = true;
		pickField.style.cursor = 'pointer';

		let dummyField = document.getElementById('date-dummy');
		pickField.name = 'date-dummy';
		dummyField.value = pickField.value;
		dummyField.name = 'date';

		var PikadayI18nNor = {
			previousMonth : 'Forrige måned',
			nextMonth     : 'Neste måned',
			months        : ['Januar','Februar','Mars','April','Mai','Juni','Juli','August','September','Oktober','November','Desember'],
			weekdays      : ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
			weekdaysShort : ['Søn','Man','Tir','Ons','Tor','Fre','Lør']
		};

		pickField.value = (new Moment(curDate)).format('D. MMMM');

	    var picker = new Pikaday({
	        field: pickField,
	        i18n: PikadayI18nNor,
	        firstDay: 1,
	        defaultDate: (new Moment(curDate)).format('D. MMMM'),
	        minDate: new Date(minDate),
	        maxDate: new Date(maxDate),
	        format: 'D. MMMM',
	        onSelect: function() {
	            dummyField.value = this.getMoment().format('YYYY-MM-DD');
	        }
	    });
	}
}
